import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable, from, of } from "rxjs";
import { catchError, map, switchMap, take, tap } from "rxjs/operators";

import {
  ASSISTANT_LAUNCH_PATH,
  ASSISTANT_LAUNCH_RETURN_URL_STORAGE_KEY,
  isAssistantLaunchReturnUrl,
} from "../shared/assistant-launch.consts";
import { AuthService } from "../shared/services/auth.service";
import { StorageService } from "../shared/services/storage.service";

@Injectable({ providedIn: "root" })
export class AssistantLaunchAuthGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.getFireAuthUser().pipe(
      take(1),
      switchMap((firebaseUser) => {
        if (firebaseUser?.uid) {
          return of(true);
        }

        return this.redirectToLogin(state.url);
      }),
      catchError(() => this.redirectToLogin(state.url))
    );
  }

  private redirectToLogin(stateUrl: string): Observable<boolean> {
    const returnUrl = isAssistantLaunchReturnUrl(stateUrl)
      ? stateUrl
      : ASSISTANT_LAUNCH_PATH;

    return from(
      this.storageService.set(
        ASSISTANT_LAUNCH_RETURN_URL_STORAGE_KEY,
        returnUrl
      )
    ).pipe(
      catchError(() => of(undefined)),
      tap(() => this.router.navigate(["/login"])),
      map(() => false)
    );
  }
}
